import { mqMin, tok, tokPx } from '@sunwebgroup/ui-components'
import * as React from 'react'
import { styled } from 'styled-components'
import { Footer } from '@/scopes/common/components'
import { Header } from '@/scopes/common/components/Header'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`

const ContentWrapper = styled.main`
  background-color: ${tok('semantics_views_tinted_background_color')};
  flex-grow: 1;
  min-height: ${tokPx('primitives_area_size_400')};
`

const Content = styled.div`
  max-width: ${tokPx('primitives_area_size_1440')};
  margin: 0 auto;
  color: ${tok('semantics_content_color')};
  padding: ${tokPx('primitives_space_16')} ${tokPx('primitives_space_16')} ${tokPx('primitives_space_32')};

  @media ${mqMin('primitives_breakpoint_m_min')} {
    padding: ${tokPx('primitives_space_24')} ${tokPx('primitives_space_32')} ${tokPx('primitives_space_32')};
  }

  @media ${mqMin('primitives_breakpoint_l_min')} {
    padding: ${tokPx('primitives_space_32')} ${tokPx('primitives_space_48')} ${tokPx('primitives_space_48')};
  }
`

const FooterStyled = styled(Footer)`
  background-color: ${tok('semantics_views_tinted_background_color')};
`

interface BookingDetailsLayoutProps {
  children: React.ReactNode
  hero?: React.ReactNode
  hideFooter?: boolean
}

export function BookingDetailsLayout({ children, hero, hideFooter }: BookingDetailsLayoutProps) {
  return (
    <Wrapper>
      <Header hideLiveSearch />
      <ContentWrapper id="main-content" tabIndex={-1}>
        {hero}
        <Content>
          {children}
        </Content>
      </ContentWrapper>
      {!hideFooter && <FooterStyled />}
    </Wrapper>
  )
}
